import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { SYSTEM_ROLE_LABELS } from "@/lib/constants";

interface RoleChangeConfirmDialogProps {
  userName: string;
  fromRole: string;
  /** Rollen som er valgt i nedtrekket; `null` = ingen dialog. */
  toRole: string | null;
  onConfirm: (role: string) => void;
  onCancel: () => void;
}

/**
 * VIB-2530: rollebytte er sjeldent og alvorlig (styrer meny- og datatilgang),
 * så det bekreftes i dialog før noe lagres. Avbryt lar rollen stå uendret.
 */
export function RoleChangeConfirmDialog({
  userName,
  fromRole,
  toRole,
  onConfirm,
  onCancel,
}: RoleChangeConfirmDialogProps) {
  const label = (r: string) => SYSTEM_ROLE_LABELS[r] ?? r;
  return (
    <AlertDialog open={toRole !== null} onOpenChange={(open) => !open && onCancel()}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Endre systemrolle?</AlertDialogTitle>
          <AlertDialogDescription>
            {userName} går fra «{label(fromRole)}» til «{toRole ? label(toRole) : ""}». Rollen
            styrer hvilke menyer og data brukeren får tilgang til, og gjelder fra neste
            sideinnlasting.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>Avbryt</AlertDialogCancel>
          <AlertDialogAction onClick={() => toRole && onConfirm(toRole)}>
            Endre rolle
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
